export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/nextBtn.59fb61e2.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};